import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  max-width: 576px;
  text-align: left;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
`;

const Text = styled.p`
  font-size: 18px;
  font-weight: 400;
`;

const BoldText = styled.span`
  font-weight: 700;
`;

const Link = styled.a`
  color: #4a90e2;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

type FinalStepProps = {
  pointDate: string;
};

const FinalStep = ({ pointDate }: FinalStepProps) => {
  return (
    <Container>
      <Title>Votre paiement a bien été enregistré !</Title>
      <Text>
        Votre inscription au <BoldText>stage des {pointDate}</BoldText> est validée.
      </Text>
      <Text>
        Dans les minutes qui viennent,{' '}
        <strong>vous allez recevoir un email de notre partenaire ActiROUTE</strong>. Vous devrez
        vous créer un compte et fournir quelques documents supplémentaires.
      </Text>
      <Text>
        Si vous ne recevez rien par email, vérifiez vos messages indésirables / spam ou
        contactez-nous par téléphone au <Link href="tel: 0970703068">09 70 70 30 68</Link>.
      </Text>
      <Text>
        <strong>
          Votre convocation définitive vous sera envoyée quelques jours avant le stage.
        </strong>
      </Text>
      <Text>
        En cas d’empêchement, vous avez la possibilité d’annuler et déplacer votre stage sous
        certaines conditions, conformément à nos{' '}
        <Link
          href="https://www.actiroute.com/conditions-generales-de-vente/"
          target="_blank"
          rel="noreferrer noopener"
        >
          Conditions générales de ventes
        </Link>
        .
      </Text>
      <Text>Bon stage !</Text>
    </Container>
  );
};

export { FinalStep };
